const createStoreEvents = (reducers) => {
  const listeners = {
    root: [],
  }

  const has = (reducerName, handler) =>
    listeners[reducerName] && listeners[reducerName].includes(handler)

  return {
    subscribe(reducerName, handler) {
      if (!listeners[reducerName]) {
        listeners[reducerName] = []
      }

      if (!has(reducerName, handler)) {
        listeners[reducerName].push(handler)
      }
    },

    unsubscribe(reducerName, handler) {
      if (has(reducerName, handler)) {
        const handlerIndex = listeners[reducerName].indexOf(handler)

        listeners[reducerName].splice(handlerIndex, 1)
      }
    },

    dispatch(newState, { type, rootType }) {
      if (type === '@@router/LOCATION_CHANGE') {
        listeners.root.forEach((handler) => {
          handler(newState)
        })

        if (listeners['routing.location']) {
          listeners['routing.location'].forEach((handler) => {
            handler(newState['routing']['location'])
          })
        }

        return
      }

      if (!rootType) {
        return
      }

      const [ rootName, reducerName, methodName ] = rootType.split('.')
      const listenerKey = `${rootName}.${reducerName}`

      if (!reducers[rootName] || !reducers[rootName][reducerName] || !reducers[rootName][reducerName][methodName]) {
        return
      }

      /*

       call all handlers that was created from {Function} mapStateToProps

       useConnect((state) => ({ count: state.models.counter.count }))

       or

       useConnect({ count: (state) => state.models.counter.count })

       */
      listeners.root.forEach((handler) => {
        handler(newState)
      })

      if (listeners[listenerKey]) {
        listeners[listenerKey].forEach((handler) => {
          handler(newState[rootName][reducerName])
        })
      }
    },
  }
}


export default createStoreEvents
